// removed by extract-text-webpack-plugin
module.exports = {"closeIcon":"G7e483d G33acf0 Gb69063 G43478c G143d95 G319350"};